import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Edit, Plus, Repeat, Trash2, UserPlus } from "lucide-react";

// Reusable program templates.
const TemplatesTab = ({
  clients,
  deleteTemplate,
  programTemplates,
  setAssignTemplateData,
  setAssignTemplateOpen,
  setEditingTemplate,
  setNewTemplate,
  setTemplateOpen,
  templateCategoryLabels,
}) => {
  return (
    <div className="templates-view">
      <div className="view-header">
        <h1>Szablony programów</h1>
        <div style={{display:'flex', gap:'8px'}}>
          <Button variant="outline" onClick={() => { setAssignTemplateData({ template_id: "", client_id: "", scheduled_date: "" }); setAssignTemplateOpen(true); }} disabled={programTemplates.length === 0 || clients.length === 0}>
            <UserPlus size={16} /> Przypisz
          </Button>
          <Button onClick={() => { setEditingTemplate(null); setNewTemplate({ name: "", category: "general", description: "", exercises: [] }); setTemplateOpen(true); }}>
            <Plus size={18} /> Nowy szablon
          </Button>
        </div>
      </div>

      {programTemplates.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <Repeat size={48} strokeWidth={1} />
            <h3>Brak szablonów</h3>
            <p>Stwórz szablony programów treningowych do wielokrotnego użytku</p>
          </CardContent>
        </Card>
      ) : (
        <div className="templates-grid">
          {programTemplates.map(tmpl => (
            <Card key={tmpl.id} className="template-card">
              <div className="template-card-actions">
                <Button variant="ghost" size="sm" onClick={() => {
                  setEditingTemplate(tmpl);
                  setNewTemplate({
                    name: tmpl.name,
                    category: tmpl.category,
                    description: tmpl.description || "",
                    exercises: (tmpl.exercises || []).map(ex => ({
                      id: ex.exercise_id,
                      name: ex.exercise_name || ex.exercise_id,
                      sets: ex.sets?.length || 3,
                      reps: ex.sets?.[0]?.target_reps || 10
                    }))
                  });
                  setTemplateOpen(true);
                }}>
                  <Edit size={14} />
                </Button>
                <Button variant="ghost" size="sm" onClick={() => deleteTemplate(tmpl.id)}>
                  <Trash2 size={14} />
                </Button>
              </div>
              <CardContent>
                <Repeat size={24} />
                <div className="template-details">
                  <h3>{tmpl.name}</h3>
                  <div className="template-meta">
                    <Badge variant="secondary">{templateCategoryLabels[tmpl.category] || tmpl.category}</Badge>
                    <span>{tmpl.exercises?.length || 0} ćwiczeń</span>
                  </div>
                  {tmpl.description && <p className="template-description">{tmpl.description}</p>}
                  <div className="template-exercises-preview">
                    {(tmpl.exercises || []).slice(0, 4).map((ex, i) => (
                      <span key={i} className="template-exercise-name">{ex.exercise_name || '?'}</span>
                    ))}
                    {(tmpl.exercises || []).length > 4 && <span className="template-exercise-name">+{tmpl.exercises.length - 4}</span>}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplatesTab;
